/* import __COLOCATED_TEMPLATE__ from './add-branch-button.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();